var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.42588 2.26454L4.27037 7.36155C4.09362 7.53494 4.0035 7.76048 4 7.98728V8.01272C4.0035 8.2391 4.09362 8.46464 4.27037 8.63803L9.42588 13.7355C9.78594 14.0882 10.3704 14.0882 10.7292 13.7355C11.0901 13.3823 11.0901 12.8117 10.7292 12.4586L6.5025 8.00042L10.7309 3.54102C10.9055 3.3689 10.9952 3.14591 11 2.92122V2.88561C10.9952 2.6605 10.9051 2.43666 10.7292 2.26454C10.5494 2.08818 10.3136 2 10.0778 2C9.84194 2 9.60569 2.08818 9.42588 2.26454Z","fill":"#3A66E5"}));
}

ChevronLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
